import { Component, OnInit } from '@angular/core'
import { MatProgressBar } from '@angular/material/progress-bar'
import { PaginationComponent } from '../../../shared/components/pagination/pagination.component'
import { TableListComponent } from '../../../shared/components/table-list/table-list.component'
import { AuthService } from '../../../core/services/auth/auth.service'
import { MatDialog } from '@angular/material/dialog'
import {
  PagedContactTypeResponse,
  SearchContactTypeModel,
} from '../../../core/models/contact-type.model'
import { FormSearchComponent } from '../../../shared/components/form-search/form-search.component'
import { MatButton } from '@angular/material/button'
import { HealthUnitService } from '../../../core/services/health-unit/location/health-unit.service'
import { HealthUnitCreateComponent } from '../../../features/health-unit/health-unit-create/health-unit-create.component'
import { HealthUnitEditComponent } from '../../../features/health-unit/health-unit-edit/health-unit-edit.component'
import { MatPaginatorModule } from '@angular/material/paginator'
import { PageEvent } from '@angular/material/paginator'
import { MunicipalityService } from '../../../core/services/municipality/municipality/municipality.service'
import { ReactiveFormsModule, FormBuilder, FormGroup } from '@angular/forms'
import { MatSelect, MatOption } from '@angular/material/select'
import { MatFormField } from '@angular/material/form-field'
import { MatLabel } from '@angular/material/form-field'
import { MatIcon } from '@angular/material/icon'

@Component({
  selector: 'health-unit',
  imports: [
    MatProgressBar,
    PaginationComponent,
    TableListComponent,
    FormSearchComponent,
    MatButton,
    MatPaginatorModule,
    // Filters (município)
    ReactiveFormsModule,
    MatSelect,
    MatOption,
    MatFormField,
    MatLabel,
    MatIcon,
  ],
  templateUrl: './health-unit.component.html',
  styleUrl: './health-unit.component.scss',
  providers: [HealthUnitService, AuthService],
  standalone: true,
})
export class HealthUnitComponent implements OnInit {
  constructor(
    private locationService: HealthUnitService,
    private authService: AuthService,
    private dialog: MatDialog,
    private municipalityService: MunicipalityService,
    private formBuilder: FormBuilder,
  ) {}

  page: number = 1
  rows: number = 10
  numberRows: number = 0
  itemsList: any[] = []
  loading: boolean = false
  searchForm: any = {}
  inputSearch: string = ''
  // Municipio filter
  form!: FormGroup
  municipiosList: any[] = []
  columns: any[] = [
    {
      keyColumn: 'nome_fantasia',
      key: 'nome_fantasia',
      description: 'Nome Fantasia',
    },
    {
      keyColumn: 'razao_social',
      key: 'razao_social',
      description: 'Razão Social',
    },
    {
      keyColumn: 'bairro',
      key: 'endereco.bairro',
      description: 'Bairro',
    },
    {
      keyColumn: 'municipio',
      key: 'municipio_nome',
      description: 'Município',
    },
    {
      keyColumn: 'estado',
      key: 'endereco.estado',
      description: 'Estado',
    },
    {
      keyColumn: 'status_id',
      key: 'status_id',
      description: 'Ativo',
    },
    {
      keyColumn: 'action',
      key: { edit: false, delete: false },
      description: 'Ações',
    },
  ]
  screen: string = 'unidade-de-saúde'

  ngOnInit() {
    this.createForm()
    this.checkColumnAction()
    this.getMunicipio()
    this.getListItems()
  }

  createForm() {
    this.form = this.formBuilder.group({
      municipio: [null],
      status: [null],
    })
  }

  getMunicipio() {
    this.municipalityService.listActiveMunicipality().subscribe({
      next: (response: any) => {
        if (response.data) {
          this.municipiosList = response.data
        }
      },
      error: (err: any) => {
        console.error(err)
      },
    })
  }

  checkColumnAction() {
    let index = this.columns.findIndex((ele: any) => {
      return ele.keyColumn == 'action'
    })
    if (index != -1) {
      this.columns[index].key = {
        edit: this.checkPermission('editar'),
        delete: this.checkPermission('excluir'),
      }
      console.log({
        edit: this.checkPermission('editar'),
        delete: this.checkPermission('excluir'),
      })
      if (!Object.values(this.columns[index].key).includes(true)) {
        this.columns.splice(index, 1)
      }
    }
  }

  checkPermission(permission: string) {
    return this.authService.checkPermission(permission, this.screen)
  }
  municipioId: number | null = null
  status_id: number | null = null
  onChange() {
    this.municipioId = this.form.get('municipio')?.value
    this.status_id = this.form.get('status')?.value
    if (this.municipioId) {
      this.searchForm.municipio_id = this.municipioId
    } else {
      if (this.searchForm.municipio_id) {
        this.searchForm.municipio_id = null
      }
    }

    this.page = 1
    this.searchListItems()
  }

  search(event: any) {
    let search = event
    this.page = 1
    if (search) {
      this.searchForm.descricao = search
      this.searchListItems()
    } else {
      this.getListItems()
    }
  }

  pageChanged(page: number) {
    this.page = page
    this.uploadList()
  }

  onPageEvent(event: PageEvent) {
    this.page = event.pageIndex + 1 // pageIndex é zero-based, a sua variável page é 1-based
    this.rows = event.pageSize
    this.uploadList()
  }

  pageSizeChanged(newPageSize: number) {
    this.rows = newPageSize
    this.page = 1 // normalmente reseta para a primeira página
    this.uploadList()
  }

  uploadList(type: string = '') {
    if (type == 'new') {
      this.searchForm = new SearchContactTypeModel()
    }
    this.municipioId = null
    this.form.get('municipio')?.setValue(null)
    this.form.get('status')?.setValue(null)
    this.getListItems()
  }

  treatResponse(response: any) {
    let list = []
    const items = Array.isArray(response?.data)
      ? response.data
      : (Array.isArray(response?.items) ? response.items : (response?.data?.items ?? []))
    for (let item of items) {
      list.push(item)
    }
    this.itemsList = list
    this.numberRows = response?.pagination?.total ?? response?.paging?.total ?? this.itemsList.length
    this.page = response?.pagination?.current_page ?? response?.paging?.current_page ?? this.page
  }

  getListItems() {
    this.loading = true
    this.locationService.listPagedLocation(this.page, this.rows).subscribe({
      next: (response: any) => {
        this.treatResponse(response)
      },
      error: (err: any) => {
        this.loading = false
      },
      complete: () => {
        this.loading = false
      },
    })
  }

  searchListItems() {
    this.loading = true
    this.locationService.listPagedLocation(this.page, this.rows, this.municipioId!, this.status_id!).subscribe({
      next: (response: any) => {
        this.treatResponse(response)
      },
      error: (err: any) => {
        this.loading = false
      },
      complete: () => {
        this.loading = false
      },
    })
  }

  newEmployee() {
    const dialogRef = this.dialog.open(HealthUnitCreateComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '950px',
      // height: '100vh',
    })
    dialogRef.componentInstance.responseCreate.subscribe((response) => {
      this.uploadList()
    })
  }

  editItem(item: any) {
    const dialogRef = this.dialog.open(HealthUnitEditComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '950px',
      data: { item },
    })
    dialogRef.componentInstance.responseEdit.subscribe((response) => {
      this.uploadList()
    })
  }

  deleteItem(item: any) {
    console.log('item delete', item)
  }
}
